
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class LanguageVariableDtoModel extends Model<LanguageVariableDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'identifier', type: 'string' },
		{ name: 'text', type: 'string' },
		{ name: 'isoCode', type: 'string' }
	];
	[key: string]: any;
	
	public identifier: string;
	public text: string;
	public isoCode: string;
    
	constructor(){
		super();
		this.identifier = '';
		this.text = '';
		this.isoCode = '';
		
	}
	getProperties(){
		return LanguageVariableDtoModel.classProperties;
	}
}

